import { ALLOWED_SPACING_TOKENS, sanitizeAllowedString, sanitizeBoolean, sanitizePositiveInteger } from './helpers';
export function sanitizeAutoColumns(el, sanitizeElement) {
  const minColumnWidth = sanitizePositiveInteger(el.minColumnWidth);
  if (minColumnWidth === undefined) {
    return null;
  }
  if (!Array.isArray(el.children)) {
    return null;
  }
  const children = el.children.map(sanitizeElement).filter(child => child !== null);
  if (children.length === 0) {
    return null;
  }
  return {
    type: 'AutoColumns',
    minColumnWidth,
    children,
    gap: sanitizeAllowedString(el.gap, ALLOWED_SPACING_TOKENS),
    divider: sanitizeBoolean(el.divider),
    anchorFirst: sanitizeBoolean(el.anchorFirst)
  };
}